export default {
  setLoading(state, value) {
    state.loading = value;
  },
  setTrialInfo(state, value) {
    state.trialInfo = value;
  },
  setAllTrialStyleIds(state, ids) {
    state.allTrialStyleIds = ids || [];
  },
  setActiveTrialSubs(state, value) {
    state.activeTrialSubs = value;
  },
  addActiveTrialSub(state, sub) {
    state.activeTrialSubs.push(sub);
  },
};
